module.exports = __webpack_public_path__ + "img/carro-compra-felicidad.2a35fbcc.webp";